import { NSASectionTabs, NSASectionTabsItemsProps, NSASectionTabsRef } from "./NSASectionTabs";
import { IEntityInfo } from "../IEntityInfo";
import { useParams } from "react-router-dom";
import { forwardRef, ReactNode, useEffect, useImperativeHandle, useRef, useState } from "react";
import { IBaseComponentProps, NSLoading } from "namirasoft-site-react";
import { NSARouterMakerProps } from "../NSARouterMakerProps";
import { CategoryRow, FieldRow } from "namirasoft-field";

export interface NSASectionViewProps<EntityType> extends IBaseComponentProps
{
	onEntityLoaded?: (item: EntityType) => void;
	getChildrenBefore?: (id: string, entity: EntityType) => ReactNode;
	getChildrenAfter?: (id: string, entity: EntityType) => ReactNode;
	ui?: {
		tabs?: NSASectionTabsItemsProps;
	};
}

interface NSASectionViewInnerProps<EntityType extends { id: string }, EntityTypeInput = EntityType> extends NSASectionViewProps<EntityType>, NSARouterMakerProps
{
	entity: IEntityInfo<EntityType, EntityTypeInput>;
	ctf: {
		enabled: boolean;
		fields: FieldRow[] | null;
		categories: CategoryRow[] | null;
	};
	deleteFieldCache: () => void;
}

interface NSASectionViewState<EntityType>
{
	entity: EntityType | null;
}

export interface NSASectionViewRef<EntityType>
{
	NSASectionTabs: NSASectionTabsRef | null
	getEnitty: () => EntityType | null;
}

export const NSASectionView = forwardRef<any, any>(<EntityType extends { id: string }, EntityTypeInput = EntityType>(
	props: Omit<NSASectionViewInnerProps<EntityType, EntityTypeInput>, "ref">,
	ref: React.Ref<NSASectionViewRef<EntityType>>
) =>
{
	let NSASectionTabs_Ref = useRef<NSASectionTabsRef>(null);

	let { id } = useParams();

	let [state, setState] = useState<NSASectionViewState<EntityType>>({ entity: null });

	useEffect(() =>
	{
		if (id)
			if (props.entity.server.get)
				props.entity.server.get(id).then((entity) =>
				{
					setState({ entity });
					if (props.onEntityLoaded)
						props.onEntityLoaded(entity);
				}).catch(() => { });
		// eslint-disable-next-line
	}, [id]);

	useImperativeHandle(ref, () => ({
		NSASectionTabs: NSASectionTabs_Ref.current,
		getEnitty: () => state.entity
	}));

	if (id && state.entity != null)
		return (
			<div
				id={props.id}
				className={`${props.classList?.join(" ") ?? ""}`}
				style={{ ...props.style }}
			>
				{props.getChildrenBefore && props.getChildrenBefore(id, state.entity)}
				<NSASectionTabs
					ref={NSASectionTabs_Ref}
					id={id ?? ""}
					{...props}
					tabs={props.ui?.tabs}
					deleteFieldCache={props.deleteFieldCache}
				/>
				{props.getChildrenAfter && props.getChildrenAfter(id, state.entity)}
			</div>
		);

	return <NSLoading></NSLoading>;
});